import { Button, Dialog, DialogActions, DialogContent, useMediaQuery,useTheme,Toolbar,AppBar,IconButton,Typography, Box} from "@mui/material";
import { useCallback, useState } from "react";
import { Close} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import DataGridV2 from "../components/DataGridV2";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../_constants";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { getLocalStorageItem, setLocalStorageItem } from "../_helpers";
import { useDispatch, useSelector } from "react-redux";
import { INITIAL_ROW_SELECTION_MODEL } from "../components/DataGridV2/constants";
import { getBuyerChangeGridColumns } from "./ChangeBuyerUtils";
import { toastActions } from "../_actions";

const ChangeBuyerDialog = ({ open, onClose, buyers, onSave }) => {
  const theme = useTheme();  
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t, i18n } = useTranslation();
  const apiRef = useGridApiRef();
  const app = useSelector((state) => state.app);
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE"  : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [selected, setSelected] = useState(null);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_PAGINATION[keyPrefix], undefined
  ));

    const processedData = [];
    console.log({processedData})
    if (buyers?.p1) {
        processedData.push({
            ...buyers.p1,
            id: buyers.p1.personId || 'p1',
            type: 'P1',
            email: buyers.p1.emailPrivate || buyers.p1.emailWork || buyers.p1.loginEmail || ''
        });
    }

    if (buyers?.p2) {
        processedData.push({
            ...buyers.p2,
            id: buyers.p2.personId || 'p2',
            type: 'P2',
            email: buyers.p2.emailPrivate || buyers.p2.emailWork || buyers.p2.loginEmail || ''
        });
    }

    if (buyers?.type === 1 && buyers?.org) {
        processedData.push({
            ...buyers.org,
            id: buyers.org.personId || 'org',
            type: 'ORG',
            email: buyers.org.email || '',
            organizationName: buyers.org.name,
            relationName: [buyers.org.initials, buyers.org.middleName, buyers.org.lastName].filter(Boolean).join(' ')
        });
    }

    const columns = getBuyerChangeGridColumns({t,keyPrefix,i18n,apiRef})

    const onPaginationModelChange = useCallback((newPaginationModel) => {
      setPaginationModel(newPaginationModel);
      setLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_PAGINATION[keyPrefix],
          newPaginationModel
      );
  }, [keyPrefix]);


   if (!buyers) {
        return []
    }

  return (
    <Dialog
      fullScreen={isMobile}
      fullWidth
      open={open}
      onClose={(event, reason) =>
        reason === "backdropClick" ? event.stopPropagation() : onClose()
      }
      PaperProps={{
        sx: {
          maxWidth: "none",
          width: 1200,
          height: { md: 650 },
        },
      }}
    >
      <AppBar position="relative" sx={{ boxShadow: "none" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            size="large"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2 }} variant="h6" component="div">
            {t("buyersGuide.buyerActions.changeBuyer")}
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent sx={{ p: 2 }}>
        <Box height={"100%"}>
          <DataGridV2
            localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_SEARCH_TEXT[keyPrefix]}
            localColumnFilterIdentifier={ LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_FILTER[keyPrefix ]}
            localColumnSortIdentifier={ LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_SORT[keyPrefix]}
            localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_ORDER[keyPrefix] }
            localColumnWidthIdentifier={ LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_WIDTH[keyPrefix]}
            localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_VISIBILITY[keyPrefix]}
            apiRef={apiRef}
            hideExportBtn={true}
            rows={processedData}
            columns={columns}
            pagination
            {...(!!paginationModel && { paginationModel })}
            onPaginationModelChange={onPaginationModelChange}
            filterMode="client"
            toolbarProps={{
              title: t("general.buyerRenter"),
              selectedRows: rowSelectionModel,
            }}
            checkboxSelection={false} 
             //TODO: after api comes handle this change buyer
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
              if (newRowSelectionModel.length > 0) {
                const selectedId =
                  newRowSelectionModel[newRowSelectionModel.length - 1];
                const selectedRow = processedData.find(
                  (r) => r.id === selectedId,
                );
                setSelected(selectedRow);
              } else {
                setSelected(null);
              }
            }}
            rowSelectionModel={rowSelectionModel}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t("general.cancel")}</Button>
        <Button
          onClick={() => {
            if (!selected) {
              dispatch(
                toastActions.error(
                  t("buyersGuide.buyerActions.change.errorToastMessage"),
                ),
              );
              return;
            }
            onSave(selected);
          }}
        >
          {t("general.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ChangeBuyerDialog
